<template>
  <div class="recruitment-wrap">
    <div class="header-bg">
      <img :src="bgUrl" alt="" v-if="bgUrl" />
      <img
        src="../../common/images/visa-change/visa-head-bg.png"
        v-else
        alt=""
      />
    </div>
    <div class="tabs-wrap">
      <tabs
        :tabsData="tabs"
        :sticky="sticky"
        @clickInfo="goodDetailTab"
        :activityIndex="activityIndex"
      >
        <recruit-list slot="0"></recruit-list>
        <bidding-list slot="1" _index="1"></bidding-list>
        <win-bidding-list slot="2" _index="2"></win-bidding-list>
      </tabs>
    </div>
  </div>
</template>

<script>
import tabs from '../../components/tabs-list-cp';
import recruitList from './components/recruit-list';
import biddingList from './components/bidding-list';
import winBiddingList from './components/win-bidding-list';
import { Sticky } from 'vant';

export default {
  components: {
    tabs,
    [Sticky.name]: Sticky,
    recruitList,
    biddingList,
    winBiddingList
  },
  data() {
    return {
      tabs: [
        { name: '招募公告', subTitle: '招募信息列表', active: 0 },
        { name: '招标公告', subTitle: '招标信息列表', active: 1 },
        { name: '中标公告', subTitle: '中标信息列表', active: 2 }
      ],
      type: 0,
      value: '',
      columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
      sticky: true,
      subTitle: '招募信息列表',
      activityIndex: 0,
      bgUrl: ''
    };
  },
  created() {
    this.$api.getBannerList({ current: 1, size: 999 }).then(res => {
      let { code, body } = res;
      if (code == '0000') {
        let { records } = body;
        records = records.filter(item => item.position == 1);
        this.bgUrl = records.length && records[0].image;
      }
    });
  },
  mounted() {},
  methods: {
    goodDetailTab(index) {
      this.type = index;
      let json = {
        0: '招募信息列表',
        1: '招标信息列表',
        2: '中标信息列表'
      };
      this.subTitle = json[index];
      window.sessionStorage.setItem('activeIndex', index);
    },
    onChange() {},
    handSearch() {}
  }
};
</script>

<style lang="scss" scoped>
.recruitment-wrap {
  background: #efefef;
  .header-bg {
    height: 160px;
    // background: url("../../common/images/visa-change/visa-head-bg.png")
    //   no-repeat center;
    // background-size: 100% 160px;
    img {
      height: 160px;
      width: 100%;
    }
  }
  .search {
    // height: 88px;
    border-bottom: 1px solid #efefef;
  }
}
</style>
